import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  ApiConfig
} from "./chunk-LPIRJEMY.mjs";
import {
  __async
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/auth/user.ts
import { getLocaleOnly, readCookie } from "@wbk/utils";
var getUser = (_0) => __async(void 0, [_0], function* ({ lang }) {
  var _a, _b, _c, _d, _e;
  try {
    const locale = getLocaleOnly(lang);
    const token = readCookie("token");
    if (!token)
      return null;
    const data = yield fetchClient({
      url: `/user/profile?lang=${locale}`,
      baseUrl: (_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.authApi
    });
    if (((_c = data.status) == null ? void 0 : _c.toLowerCase()) !== "success") {
      const msg = Object.values((data == null ? void 0 : data.error) || {})[0] || ((_e = (_d = data == null ? void 0 : data.original) == null ? void 0 : _d.error) == null ? void 0 : _e.description);
      const finalMsg = Array.isArray(msg) ? msg[0] : msg;
      throw new Error(finalMsg);
    }
    return data.data;
  } catch (error) {
    return null;
  }
});

export {
  getUser
};
//# sourceMappingURL=chunk-3PCNV5OU.mjs.map